import { render, staticRenderFns } from "./taskProcessExample.vue?vue&type=template&id=1c4916a2&scoped=true&"
import script from "./taskProcessExample.vue?vue&type=script&lang=js&"
export * from "./taskProcessExample.vue?vue&type=script&lang=js&"
import style0 from "./taskProcessExample.vue?vue&type=style&index=0&id=1c4916a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4916a2",
  null
  
)

export default component.exports